import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
function App({ RouterComponent = BrowserRouter, routerProps, staticHomepage }) {
  return (
    <>
      <Routes
        RouterComponent={RouterComponent}
        routerProps={routerProps}
        staticHomepage={staticHomepage}
      />
      <Analytics />
      <SpeedInsights/>
    </>
  );
}

export default App;
